import { GetterTree } from 'vuex';
import { RootState, ListStatus } from '@/store/types';
import { SendGridEmailState } from './types';

export const moduleGetters: GetterTree<SendGridEmailState, RootState> = {
  isLoading: (state) => state.status === ListStatus.Loading,
  isLoaded: (state) => state.status === ListStatus.Loaded,
  isError: (state) => state.status === ListStatus.Failed,
  isEmpty: (state, getters) => getters.isLoaded && !state.list.length,
};

export default moduleGetters;
